<template>
  <ChampSuggestions
    :id="id"
    :model-value="modelValue"
    :state="state"
    :chercher="chercher"
    :cle="(a: AdresseSuggestionDto) => a.label"
    :min="3"
    :compact="compact"
    :placeholder="placeholder"
    libelle-liste="Adresses proposées"
    libelle-vide="Aucune adresse reconnue : précisez, ou gardez votre saisie."
    libelle-indisponible="Suggestions indisponibles : saisissez l’adresse librement."
    @update:model-value="emit('update:modelValue', $event)"
    @choisi="(a: AdresseSuggestionDto) => emit('update:modelValue', a.label)"
  >
    <template #option="{ item: a }">
      <span class="text-space-indigo dark:text-altoneo-50">{{ a.label }}</span>
      <span v-if="a.contexte" class="block truncate text-xs text-slate-500 dark:text-alt-dark-muted">{{ a.contexte }}</span>
    </template>
  </ChampSuggestions>
</template>

<script setup lang="ts">
import type { AdresseSuggestionDto } from '@igd/shared';
import { api } from '@/lib/api';
import ChampSuggestions from '@/components/ChampSuggestions.vue';

/**
 * Champ d'adresse qui PROPOSE des adresses au fil de la frappe (Base Adresse
 * Nationale, via l'API). Une adresse choisie dans la liste est une adresse que
 * « Calculer la distance » retrouvera du premier coup.
 *
 * Le champ reste LIBRE : un chantier ou une adresse étrangère se saisit à la main.
 */
withDefaults(
  defineProps<{
    modelValue: string;
    id?: string;
    state?: 'default' | 'error';
    placeholder?: string;
    compact?: boolean;
  }>(),
  { id: undefined, state: 'default', placeholder: 'N°, rue, code postal, ville', compact: false },
);
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

const chercher = (terme: string): Promise<AdresseSuggestionDto[]> =>
  api.get<AdresseSuggestionDto[]>(`/adresses?q=${encodeURIComponent(terme)}`);
</script>
